<template>
    <div class="search-panel">
        <transition name="fade-filter" mode="out-in">
            <SkeletonLoader v-if="isLoading" />
            <Filters v-else
                     :data="data"
                     :isMobile="isMobile"
                     :windowWidth="windowWidth"
                     @changeFilter="changeFilter"/>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import Filters from './Filters/Filters.vue';
import PreloaderIcon from './media/preloader-icon.vue';
import SkeletonLoader from "./SkeletonLoader/SkeletonLoader.vue";
import {Utils} from '../../common/scripts/utils';

export default {
    data() {
        return {
            // позиционирование поиска
            position   : this.$dataset.position || 'static',
            // прелоадер
            isLoading  : true,
            // ширина экрана
            windowWidth: Utils.getWindowWidth(),
            // данные для отправки на сервер
            sendData   : new FormData(),
            // данные, полученные с сервера
            data       : {},
            // менял ли пользователь цену
            priceChange: {
                min: false,
                max: false
            },
            // url
            url: this.$dataset.url || '/tests/searchresult.php'
        };
    },

    computed: {
        isMobile() {
            return this.windowWidth < 960;
        }
    },

    components: {
        Filters,
        PreloaderIcon,
        SkeletonLoader
    },

    mounted() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this.onResize);
        });

        this.send('init');
    },

    unmount() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.removeEventListener(event, this.onResize, false);
        });
    },

    methods: {
        onResize() {
            this.windowWidth = Utils.getWindowWidth();
        },

        /**
         * Добавляем data аттрибуты от главного элемента
         * @param {Object} formData - данные, куда присваиваются аттрибуты
         */
        addMainDataset(formData) {
            if (this.$dataset) {
                for (const key in this.$dataset) {
                    if (Object.prototype.hasOwnProperty.call(this.$dataset, key)) {
                        if (!formData.has(key) && key !== 'url') {
                            formData.append(key, this.$dataset[key]);
                        }
                    }
                }
            }
        },

        /**
         * Отправка данных на сервер
         * @param {String} typeRequest - тип запроса
         */
        send(typeRequest = '') {
            // Добавляем дата-атрибуты
            this.addMainDataset(this.sendData);

            // Определяем тип поиска
            if (typeRequest === 'init') {
                this.sendData.append('type', 'init');
            } else {
                this.sendData.append('type', 'filter');
            }

            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.post(this.url, this.sendData).then((response) => {
                const status = response.data.success;

                if (status) {
                    this.data = response.data.data;
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .then(() => {
                this.isLoading = false;
            });
        },

        changeFilter(form) {
            this.sendData = new FormData(form);

            this.send('filter');
        }
    }
};
</script>
